import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '../../../shared-with-client/button/button.component';
import { TextInputComponent } from '../../../shared-with-client/text-input/text-input.component';
import { MerchantsService } from '../../../core/services/merchants.service';
import { ToolsService } from '../../../core/services/tools.service';
import { CommissionTypeOptions, InvoicingService } from '../../../core/services/invoicing.service';
import { ToastNotificationsService } from '../../../core/services/toast-notifications.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-edit-commission-modal',
  imports: [TextInputComponent, ButtonComponent, ReactiveFormsModule, TranslatePipe],
  templateUrl: './edit-commission-modal.component.html',
  styleUrl: './edit-commission-modal.component.scss'
})
export class EditCommissionModalComponent {
  private formBuilder = inject(FormBuilder);
    private merchantService = inject(MerchantsService);
    private toolsService = inject(ToolsService);
    private modalService = inject(BsModalService);
    private invoicingService = inject(InvoicingService);
    private toastNotificationsService = inject(ToastNotificationsService);
    private translateService = inject(TranslateService);

    public currentMerchant = toSignal(this.merchantService.activeMerchant);

    public commission: any;

    submitAttempted = signal<any>(false);
    form!: FormGroup;

    public CommissionTypeOptions = CommissionTypeOptions;

    public merchantCurrency = (this.toolsService.formatAsCurrency(0, this.currentMerchant()?.currency)?.replace('0', '') || '€')?.trim();

    public saving = signal(false);

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            commissionType: [this.commission.commissionType ?? CommissionTypeOptions.PERCENTAGE, []],
            commissionValue: [this.commission.commissionValue ?? 0, [Validators.min(0)]],
        });

        this.updateCommissionValidators();
        this.form.get('commissionType')?.valueChanges.subscribe(() => {
            this.updateCommissionValidators();
        });
    }

    updateCommissionValidators() {
        const type = this.form.get('commissionType')?.value;
        const valueControl = this.form.get('commissionValue');

        valueControl?.clearValidators();
        const validators = [Validators.min(0)];

        if (type === CommissionTypeOptions.PERCENTAGE) {
            validators.push(Validators.max(100));
        }

        valueControl?.setValidators(validators);
        valueControl?.updateValueAndValidity();
    }

    save() {
        this.submitAttempted.set(true);
        if (!this.form.valid) {
            return;
        }

        this.saving.set(true);

        this.invoicingService.editCommission(this.commission.id, this.form.value).subscribe({
            next: () => {
                this.saving.set(false);
                this.toastNotificationsService.showToast(this.translateService.instant('GENERAL.savedSuccessfully'), 'success');
                this.modalService.setDismissReason('saved');
                this.modalService.hide();
            },
            error: (error) => {
                this.toastNotificationsService.showToast(error?.errMsg || this.translateService.instant('GENERAL.generalErrorMsg'), 'error');
                this.saving.set(false);
            },
        });
    }

    cancel() {
        this.modalService.hide();
    }
}
